import { render, staticRenderFns } from "./DefinitionsList.vue?vue&type=template&id=22be3078&scoped=true&lang=pug&"
import script from "./DefinitionsList.vue?vue&type=script&lang=ts&"
export * from "./DefinitionsList.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionsList.vue?vue&type=style&index=0&id=22be3078&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be3078",
  null
  
)

export default component.exports